import type { CompiledFieldNode, CompiledForm, CompiledNode } from '@record-fill';

// Added-row cell nodes live inside the table nodes, not in form.fields: the sheet looks them up
// by their display id to decide whether a positioned server issue points at something visible.
export function collectExtraCellNodes(form: CompiledForm): Record<string, CompiledFieldNode> {
  const byId: Record<string, CompiledFieldNode> = {};

  const walk = (node: CompiledNode): void => {
    if (node.kind !== 'table') return;
    for (const row of node.cells) {
      for (const cell of row) {
        if (cell.node) walk(cell.node);
      }
    }
    for (const extraRow of node.extraRows) {
      for (const cell of extraRow.cells) {
        if (cell.node) byId[cell.node.id] = cell.node;
      }
    }
  };

  form.nodes.forEach(walk);
  return byId;
}
